import { Dialog, DialogContent, DialogTitle } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { Transaction } from '../../../models/transactions';
import CreateTransactionForm from '../forms/create-transaction-form';
import { FormState } from '../forms/transaction-form';

interface Props {
  show: boolean;
  transaction?: Transaction;
  onCopied: () => void;
  onClose: () => void;
}

function CopyTransactionModal({ show, transaction, onCopied, onClose }: Props) {
  const { t } = useTranslation();

  const getCopyInitialValues = (): FormState | undefined => {
    if (!transaction) return undefined;
    return {
      date: new Date(),
      type: transaction.type,
      otherAccount: transaction.account || undefined,
      account: transaction.otherAccount || undefined,
      category: transaction.category || undefined,
      amount: transaction.amount,
      description: transaction.description,
    };
  };

  return (
    <Dialog open={show} onClose={onClose} fullWidth maxWidth="xs">
      <DialogTitle>{t('COPY_TRANSACTION')}</DialogTitle>
      <DialogContent dividers>
        <CreateTransactionForm
          onSuccess={onCopied}
          onCancel={onClose}
          isDialog={true}
          initialValues={getCopyInitialValues()}
        />
      </DialogContent>
    </Dialog>
  );
}

export default CopyTransactionModal;
